import GeneratedOrganizationStore from "./generated/GeneratedOrganizationStore"

class OrganizationStore extends GeneratedOrganizationStore {

}

export const organizationStore = new OrganizationStore()
